/**
 * Relocates the search results count + sort bar (Horizon's
 * .facets-controls-wrapper) to sit directly beneath the "We found N results"
 * summary, inside the product column — matching the reference plpSearch layout
 * (heading, then "N PRODUCTS / SORT BY", then the grid).
 *
 * Horizon renders that bar as a full-width element at the very top of the
 * collection grid, so we move it in the DOM. Horizon re-renders the section on
 * filter/sort changes, which would undo the move, so a MutationObserver
 * re-applies it. The relocation is idempotent (only acts when out of place),
 * so it cannot loop.
 */
(function () {
  function relocate() {
    const container = document.querySelector('.product-grid-container');
    if (!container) return;
    const controls = container.querySelector('.facets--horizontal.facets-controls-wrapper');
    if (!controls) return;

    const summary = container.querySelector('.search-results__summary');
    if (summary) {
      // Search: count + sort sit directly beneath the "We found N results" line.
      if (summary.nextElementSibling === controls) return; // already in place
      controls.classList.add('vv-results-toolbar');
      summary.insertAdjacentElement('afterend', controls);
      return;
    }

    // Collection: pin the count + sort bar to the top of the product column,
    // above the grid — or above the empty state when no products match (no
    // .product-grid is rendered then, but the column wrapper still exists).
    const column = container.querySelector('.main-collection-grid');
    if (!column) return;
    const content =
      column.querySelector('.product-grid') ||
      column.querySelector('.main-collection-grid__empty');
    const target = content ? content.parentElement : null;
    if (!target) return;
    if (target.firstElementChild === controls) return; // already in place
    controls.classList.add('vv-results-toolbar');
    target.insertBefore(controls, target.firstElementChild);
  }

  function init() {
    relocate();
    const container = document.querySelector('.product-grid-container');
    if (!container) return;
    const observer = new MutationObserver(() => relocate());
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
